import React from 'react';
import { oneOf } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  type: oneOf(['text']),
  size: oneOf(['narrow', 'wide']),
};

const CLASS_ROOT = 'container';

const Container = ({ className, type, size, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${type}`]: type,
      [`${CLASS_ROOT}--${type}-${size}`]: type && size,
    },
    className
  );

  return <div className={classes} {...other} />;
};

Container.displayName = 'Container';
Container.propTypes = propTypes;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Grid/Container.js